import { render } from "./BlankPageSalesEight.vue?vue&type=template&id=4b0c7f52&scoped=true"
import script from "./BlankPageSalesEight.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesEight.vue?vue&type=script&lang=js"

import "./BlankPageSalesEight.vue?vue&type=style&index=0&id=4b0c7f52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c7f52"]])

export default __exports__